import { useCallback, useState } from "react"
import DataTable from "react-data-table-component"
import { MDBIcon } from "mdb-react-ui-kit"

const customStyles = {
  rows: {
    style: {
      maxHeight: "35px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
}

interface DataTableCustomProps<T> {
  keyDataTable: string
  columns: any[]
  data: T[]
  sortFieldId?: number
  sortAsc?: boolean

  /** Opcional: control externo de paginación */
  currentPage?: number
  setCurrentPage?: (page: number) => void
  rowsPerPage?: number
  setRowsPerPage?: (rows: number) => void  
}

const DataTableCustom = <T,>({
  keyDataTable,
  columns,
  data,
  sortFieldId = 0,
  sortAsc = true,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,  
}: DataTableCustomProps<T>) => {
  /** PAGE */
  const [internalPage, setInternalPage] = useState(1)
  const isPageControlled = typeof currentPage === "number" && !!setCurrentPage
  const page = isPageControlled ? currentPage : internalPage

  const handleChangePage = useCallback(
    (page: number) => {
      isPageControlled ? setCurrentPage(page) : setInternalPage(page)
    },
    [isPageControlled, setCurrentPage]
  )

  /** ROWS PER PAGE */
  const [internalRows, setInternalRows] = useState(10)
  const isRowsControlled =
    typeof rowsPerPage === "number" && !!setRowsPerPage

  const rows = isRowsControlled ? rowsPerPage : internalRows

  const handleChangeRowsPerPage = useCallback(
    (newRows: number, page: number) => {
      isRowsControlled ? setRowsPerPage(newRows) : setInternalRows(newRows)

      // 🔑 importante: mantener coherencia de page
      handleChangePage(page)
    },
    [isRowsControlled, setRowsPerPage, handleChangePage]
  )

  return (
    <DataTable
      key={keyDataTable}
      style={{ minWidth: "800px", width: "100%" }}
      columns={columns}
      data={data}

      defaultSortFieldId={sortFieldId}
      defaultSortAsc={sortAsc}
      sortIcon={<MDBIcon icon="long-arrow-alt-up" />}

      pagination
      paginationDefaultPage={page}
      paginationPerPage={rows}
      paginationResetDefaultPage={false}

      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}

      selectableRows={false}
      highlightOnHover
      progressPending={false}
      customStyles={customStyles}
      paginationComponentOptions={{
        rowsPerPageText: "Filas por página:",
        rangeSeparatorText: "de",
      }}
    />
  )
}

export default DataTableCustom
